import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RdsApiService } from '@rds/shared-api';
import { Observable, of } from 'rxjs';

import { RdsDataProductDialogService } from '../../data-product-selection-dialog/data-product-dialog.service';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Protect routes that require a data product to be selected.
 * If a data product is not selected, it will open the data product selection dialog.
 */
@Injectable({ providedIn: 'root' })
export class RdsDataProductGuard implements CanActivate {
  constructor(
    protected dataProductDialog: RdsDataProductDialogService,
    protected rdsApiService: RdsApiService,
    protected router: Router,
    private snackbar: MatSnackBar
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (this.rdsApiService.isCatalogIdSet() && this.rdsApiService.isDataProductIdSet()) {
      return of(true);
    } else {
      this.snackbar.open($localize`Please select a data product to continue.`, $localize`DISMISS`, {
        duration: 8000,
      });
      return of(this.router.createUrlTree(['/data-product-selection']));
    }
  }
}
